import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="battle--players-edit-form"
export default class extends Controller {
  static targets = [
    "playerParticipatedInput",
    "playerScoresInput",
    "playerKillsInput",
    "playerAssistsInput",
    "playerRescuesInput",
    "playerFlagsInput",
  ];
  static values = { url: String };

  connect() {
    // console.log(this.urlValue);
    // this.playerParticipatedTarget.innerHTML = `<input type="checkbox" value="${this.playerParticipatedTarget.textContent.trim()}" data-editable-row-target="playerParticipatedInput">`;
    // this.playerKillsTarget.innerHTML = `<input type="text" value="${this.playerKillsTarget.textContent.trim()}" data-editable-row-target="playerKillsInput">`;
    // this.playerValueTarget.innerHTML = `<input type="text" value="${this.playerValueTarget.textContent.trim()}" data-editable-row-target="playerValueInput">`;
  }

  updateField(event) {
    const input = event.target;
    const field = input.dataset.field;
    const value = input.type === "checkbox" ? input.checked : input.value;

    if (event.type === "keydown" && event.key !== "Enter") {
      return; // Only proceed if Enter is pressed
    }

    // Build the request payload
    const data = {
      battle_player: {
        [field]: value,
      },
    };

    // Send a PATCH request to update the field
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
      },
      body: JSON.stringify(data),
    })
        .then((response) => {
          if (!response.ok) {
            console.error(`Failed to update ${field}`);
          } else {
            console.log(`Updated ${field}`);
          }
        })
        .catch((error) => {
          console.error("Error updating field:", error);
        });
  }
}
